/**
 * Time grid for flight scheduling. Same scheme as v1: half-hour slots
 * 07:00 to 22:00 inclusive. Re-used by the Solicitar form's hora
 * picker.
 */
export function generateTimeGrid(): string[] {
  const out: string[] = [];
  for (let h = 7; h <= 22; h++) {
    out.push(`${String(h).padStart(2, "0")}:00`);
    if (h < 22) out.push(`${String(h).padStart(2, "0")}:30`);
  }
  return out;
}
